<template>
  <!-- style="position: relative;height: 800px;overflow: scroll;" -->
  <div
    class="director-check__form"
  >
    <div
      class="collapse-box"
    >
      <gtable-crud
        ref="gtable-crud"
        :data="data"
        :option="option"
        :page="page"
        :loading="loading"
        :before-close="(done)=>done()"
        @pageChange="pageChange"
        @pageSizeChange="pageSizeChange"
        @downLoad="downLoad"
        @upload="upload"
        @refresh-change="refreshChange"
      >
        <template
          slot="menuLeft"
          slot-scope="{row}"
        >
          <my-tooltip :tooltip="$t('_components.btns.edit')">
            <feather-icon
              v-if="currentStatus !== 1"
              icon="Edit2Icon"
              size="20"
              style="margin-left: 1rem"
              class="cursor-pointer"
              @click="handleFormOpen('attendanceDetail',row)"
            />
          </my-tooltip>
        </template>
        <!-- add-表单弹窗 -->
        <template
          slot="viewDrawer"
          slot-scope="{row}"
        >
          <template>
            <my-form
              :data="row"
              :loading="formLoading"
              :option="{columns:viewCols}"
              page-key="view"
            />
          </template>
        </template>
        <template
          slot="editDrawer"
          slot-scope="{row}"
        >
          <my-form
            :data="row"
            :loading="formLoading"
            :option="{columns:editTimeCols}"
            page-key="edit"
            @submit="submitEdit"
          />
        </template>
      </gtable-crud>
    </div>

    <c-drawer
      v-model="drawerVisible"
      :before-close="handleBeforeClose"
    >
      <component
        :is="formVisibleType"
        v-if="drawerVisible"
        :supervisor-id="currentId"
        :month="currentMonth"
        :date="currentDate"
        :default-form="searchQuery"
        @closeForm="closeForm"
        @submit="submitCallBack"
      />
    </c-drawer>
    <b-modal
      :header="true"
      :dialog-class="dialogClass"
      size="lg"
      :footer="false"
      :visible="dialogShow"
      :modal-class="{'attendanceDetail-modal': true,'modal-footer-hide': true}"
      @close="dialogShow=false"
    >
      <div style="width: 100%;height: 500px">
        <my-form
          width="100%"
          :data="row"
          :loading="formLoading"
          :option="{columns:editTimeCols}"
          page-key="edit"
          @submit="submitEdit"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  getDetailList, getDetailInfoList, updateCheckTime, downloadTable, checkAttendance, uploadTable,
} from '@/api/worker/attendanceExamine/directorExamine'
import CModal from '@/components/crud/modal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BButton, BDropdownItem, BRow, BBadge, BModal,
} from 'bootstrap-vue'
import MyTooltip from '@/components/myTooltip.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { deepClone } from '@/util/util'
// import MyForm from '@/components/myForm/index.vue';
import CDrawer from '@/components/drawer.vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import { dateFormat } from '@/util/date'
// updateAttendance
import { getAttendancePage, updateAttendance, sitedirectCheck } from '@/api/worker/attendance/attendance'

export default {
  name: 'MyComponent',
  components: {
    MyForm: () => import('@/components/myForm/index.vue'),
    BBadge,
    CDrawer,
    CModal,
    BModal,
    MyTooltip,
    // attendanceDetailForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    currentDate: {
      type: String,
      default: '',
    },
    currentId: {
      type: String,
      default: '',
    },
    currentStatus: {
      type: Number,
    },
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 12,
      },
      // currentId: '',
      currentMonth: '',
      uploading: false,
      data: [],
      timeData: [],
      timeForm: {},
      stickyHeader: true,
      dialogShow: false,
      loading: false,
      formLoading: false,
      drawerTitle: '',
      drawerVisible: false,
      formVisibleType: '',
      visible: false,
      form: {},
      extendsLists: [],
      extendsKeys: [],
      formVisibleEdit: false,
      currentData: {},
      row: {},
    };
  },
  computed: {
    ...mapGetters(['userAllInfo', 'userInfo']),
    editTimeCols() {
      const amPm = [
        {
          label: '0',
          value: 0,
        },
        {
          label: '1',
          value: 1,
        },
        {
          label: '2',
          value: 2,
        },
        {
          label: '3',
          value: 3,
        },
        {
          label: '4',
          value: 4,
        },
      ]
      const otList = [
        {
          label: '0',
          value: 0,
        },
        {
          label: '1',
          value: 1,
        },
        {
          label: '2',
          value: 2,
        },
        {
          label: '3',
          value: 3,
        },
        {
          label: '4',
          value: 4,
        },
        {
          label: '5',
          value: 5,
        },
        {
          label: '6',
          value: 6,
        },
      ]

      const bonusList = [
        {
          label: '0',
          value: 0,
        },
      ]
      const sunDayList = [
        {
          label: '0',
          value: 0,
        },
      ]
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i <= 16; i++) {
        bonusList.push({
          label: 20 + i * 5,
          value: 20 + i * 5,
        })
      }
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i <= 44; i++) {
        sunDayList.push({
          label: 20 + i * 5,
          value: 20 + i * 5,
        })
      }
      const cols = [
        {
          label: 'Am',
          field: 'am',
          formOption: {
            span: 6,
            type: 'select',
            dictData: amPm,
          },
        },
        {
          label: 'Pm',
          field: 'pm',
          formOption: {
            span: 6,
            type: 'select',
            dictData: amPm,
          },
        },
        {
          label: 'Ot',
          field: 'otHours',
          formOption: {
            span: 6,
            type: 'select',
            dictData: otList,
          },
        },
        {
          label: 'Bonus',
          field: 'bonus',
          formOption: {
            span: 6,
            type: 'select',
            dictData: moment(this.currentData.attendanceDate).weekday() === 6 ? sunDayList : bonusList,
          },
        },
      ]
      return cols
    },
    getAttendanceType() {
      return ['am', 'pm', 'ot', 'bonus']
    },
    viewCols() {
      const cols = [
        {
          label: '年份',
          field: 'year',
        },
        {
          label: '月份',
          field: 'month',
          formOption: {
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM do yy',
          },
        },
      ]
      return cols
    },
    option() {
      const columns = [
        {
          label: this.i18n('attendance.name'),
          field: 'name',
          searchBase: true,
          search: true,
        },
        {
          label: this.i18n('attendanceExamine.attendanceDate'),
          field: 'attendanceDate',
          // dictBizCode: 'projectId',
          // dictField: 'projectName',
        },
        {
          label: this.i18n('attendance.clockInTime'),
          field: 'clockInTime',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendance.clockOutTime'),
          field: 'clockOutTime',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendance.clockInStatus'),
          field: 'clockInStatus',
          dictField: 'clockInStatusName',
          type: 'select',
          dictBizCode: 'clock_out_status',
          dicName: 'clockInStatusName',
          formOption: {
            rules: 'required',
            editHide: true,
            type: 'select',
            dictBizCode: 'clock_in_status',
          },
        },
        {
          label: this.i18n('attendance.clockOutStatus'),
          field: 'clockOutStatus',
          dictField: 'clockOutStatusName',
          type: 'select',
          dictBizCode: 'clock_out_status',
          dicName: 'clockOutStatusName',
          formOption: {
            rules: 'required',
            type: 'select',
            dictBizCode: 'clock_out_status',
          },
        },
        {
          label: 'clockinLat',
          field: 'clockInLatLon',
          hide: true,
          formSlot: true,
          formOption: {
            slot: true,
          },
        },
        {
          label: 'clockoutLat',
          field: 'clockOutLatLon',
          hide: true,
          formOption: {
            slot: true,
          },
        },
        {
          label: this.i18n('attendance.clockStatus'),
          field: 'status',
          type: 'select',
          dictField: 'statusName',
          dictBizCode: 'attendance_status',
          search: true,
          searchBase: true,
          formOption: {
            type: 'select',
            editHide: true,
            dictBizCode: 'attendance_status',
          },
        },
        {
          label: 'AM',
          field: 'am',
        },
        {
          label: 'PM',
          field: 'pm',
        },
        {
          label: 'OT',
          field: 'otHours',
        },
        {
          label: 'BONUS',
          field: 'bonus',

        },
        ...this.extendsLists,
      ]
      const option = {
        header: false, // 显示顶部功能区(默认 true)
        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false,
        editBtn: false,
        delBtn: false, // 删除按钮(默认 true)
        batchDelBtn: false, // 批量删除按钮(默认 false)
        upLoadBtn: true, // 上传按钮(默认 false)
        downLoadBtn: true, // 下载按钮(默认 false)

        search: false, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: false, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        selection: true, // 复选框(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)
        columns,
      }
      return option
    },
  },
  mounted() {
    this.onLoad(this.page)
  },
  methods: {
    submitEdit(row) {
      const date = moment(this.currentDate).format('YYYY-MM')
      const temp = {
        am: row.am,
        pm: row.pm,
        otHours: row.otHours,
        bonus: row.bonus,
        remark: row.remark,
        id: this.currentData.id,
        date,
      }

      updateAttendance(temp).then(res => {
        this.onLoad(this.page)
        this.dialogShow = false
      })
    },
    handleEditDraw() {
      this.formVisibleEdit = true
    },
    validationForm() {
      sitedirectCheck().then(res => {
        this.$emit('closeForm')
      })
    },
    cancel() {
      this.$emit('closeForm')
    },
    getStatusList(str) {
      const lists = str && str.split(',')
      return lists
    },
    getDateBadge(index) {
      const statusList = ['light-primary', 'light-warning', 'light-success', 'light-info']
      return statusList[index]
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
    getStatusOption(status) {
      return this.statusOption[status] || {}
    },
    async onLoad(page, params = {}) {
      this.loading = true
      const userId = this.userAllInfo.id
      const day = moment(this.currentDate).format('DD')
      // 上月份20日
      const lastMonth = moment(this.currentDate).subtract(1, 'M')
      const lastMonthDay = `${moment(lastMonth).format('YYYY-MM')}-21`
      // 这月份21日
      const currentMonthDay = `${moment(this.currentDate).format('YYYY-MM')}-20`
      const res = await getAttendancePage(page.currentPage, page.pageSize, Object.assign(params, {
        workerId: this.currentId,
        attendanceDateStart: lastMonthDay,
        attendanceDateEnd: currentMonthDay,
      }, this.query))
      const { data } = res
      const temp = data.data.records
      this.page.total = data.data.total;
      this.page.pageSize = data.data.size;
      this.page.currentPage = data.data.current;
      this.data = temp
      this.loading = false
    },
    submitCallBack() {
      this.drawerVisible = false
      this.onLoad(this.page)
    },
    onClose() {
      this.visible = false
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      this.query = e
      this.page.currentPage = 1;
      await this.onLoad(this.page, e);
      done();
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page);
    },
    getBlobObj(context, fileName) {
      const blob = new Blob([context]);
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url
      a.download = fileName
      a.click();
      window.URL.revokeObjectURL(url);
    },
    downTableLoad(e) {
      downloadTable().then(res => {
        this.getBlobObj(res.data, `${this.date}报表数据.xlsx`)
      })
    },
    // 点击下载按钮
    downLoad(e) {
      // 返回复选框选中数据
      console.log(e, 'downLoad')
    },
    // 点击上传按钮
    handleUpLoad(params) {
      this.uploading = true
      uploadTable('file', params.file).then(res => {
        this.uploading = false
        this.onLoad(this.page);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      }).catch(err => {
        this.uploading = false
      })
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    getSelectedRows() {
    // 调用该方法可以获取复选框勾选数据
      const rows = this.$refs['gtable-crud'].getSelectedRows();
    },
    handleFormOpen(key, row) {
      if (row && row.workerId) {
        // this.currentId = row.id
        this.currentData = row
        this.row = JSON.parse(JSON.stringify(row))
      }
      this.dialogShow = true
      this.formVisibleType = `${key}Form`
      this.form = deepClone(row)
    },
    // i18n
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    handleBeforeClose(done) {
      this.drawerVisible = false
      done()
    },
    closeForm() {
      this.drawerVisible = false
    },
  },
};
</script>

<style lang="scss">
.dialogClass {
  z-index: 999;
}
.director-check__form {
    padding: 10px;
    overflow: scroll;
    height: 100%;
    .collapse-box{
      transition: width .3s;
      position: relative;

      &-right{
        position: absolute;
        height: 100%;
        top: 0;
      }
    }
}

.attendanceDetail-modal {
  .modal-dialog {
    width: 80vw;
  }
}
</style>
<style lang="scss" scoped>
.person-body {
  // padding: 10px;
  width: 460px;
  margin: 0 auto;
  margin-right: 20px;
}
.audit-container{
  text-align: center;
}

</style>
